import $ from 'jquery';

const $body = $('body');

function addAnimationOpenClass($el, classNamePrefix, time = 150) {
  const [cOpening, cOpen] = [`${classNamePrefix}--opening`, `${classNamePrefix}--open`];
  $el.addClass(cOpening);
  setTimeout(() => {
    $el.addClass(cOpen);
  }, 10);
  setTimeout(() => {
    $el.removeClass(cOpening);
  }, time);
}

function removeAnimationOpenClass($el, classNamePrefix, time = 150) {
  const [cClosing, cOpen] = [`${classNamePrefix}--closing`, `${classNamePrefix}--open`];
  $el.addClass(cClosing).removeClass(cOpen);
  setTimeout(() => {
    $el.removeClass(cClosing);
  }, time);
}

class Toast {
  constructor(opt = {}) {
    let className = (this.className = 'como-toast');
    this.el = {};
    let $toast = (this.el.$toast = $(`
      <div class="${className}">
        <div class="${className}__surface">
          <div class="${className}__icon material-icons-outlined"></div>
          <div class="${className}__text"></div>
        </div>
      </div>`));
    this.el.$icon = $toast.find(`.${className}__icon`);
    this.el.$text = $toast.find(`.${className}__text`);
    this.defaultDuration = opt.defaultDuration || 3000;
  }
  show(text, icon, duration = this.defaultDuration) {
    let {
      el: { $toast, $icon, $text },
      className,
      hideTimeout,
    } = this;
    if (icon) {
      $icon.removeClass('hidden').text(icon);
    } else {
      $icon.addClass('hidden');
    }
    console.log(text.includes('<a'));
    if (text.includes('<a')) {
      $text.html(text);
    } else {
      $text.text(text);
    }
    $body.append($toast);
    addAnimationOpenClass($toast, className);
    clearTimeout(hideTimeout);
    if (duration) {
      this.hideTimeout = setTimeout(() => this.hide(), duration);
    }
  }
  hide() {
    let {
      el: { $toast },
      className,
    } = this;
    removeAnimationOpenClass($toast, className);
  }
  success(text, duration = this.defaultDuration) {
    this.show(text, 'done', duration);
  }
  fail(text, duration = this.defaultDuration) {
    this.show(text, 'priority_high', duration);
  }
}

if (!$.elfn) {
  $.elfn = {};
}
$.extend($.elfn, {
  toast: new Toast(),
});
